import { Icons } from "assets";
import classNames from "classnames";
import { useEffect, useState } from "react";
import CustomPagination from "shared/components/common/customPagination";
import CustomTable from "shared/components/common/customTable";
import CustomToolTip from "shared/components/common/customToolTip";
import { toastMessage } from "shared/components/common/toast";
import SkeletonLoader from "shared/loaders/skeleton";
import ConfirmationModal from "shared/modal/confirmation";
import {
  DeleteSupportMessageService,
  GetAllSupportMessagesService,
} from "shared/services/support";
import { handleErrors } from "shared/utils/helper";
import styles from "./style.module.scss";
import SupportViewModal from "shared/modal/supportViewModal";

const SupportMessages = () => {
  const [currentPage, setCurrentPage] = useState<number>(1);
  const [confirmModal, setConfirmModal] = useState<boolean>(false);
  const [selectedMessage, setSelectedMessage] = useState<any>(null);
  const [loading, setLoading] = useState<boolean>(true);
  const [deleteLoading, setDeleteLoading] = useState<boolean>(false);
  const [messages, setSupportMessages] = useState<any[]>([]);
  const [totalItems, setTotalItems] = useState<number>(0);
  const [showDetails, setShowDetails] = useState<boolean>(false);

  const handleShowDetails = () => {
    setShowDetails(true);
  };

  const handleHideDetails = () => {
    setShowDetails(false);
  };

  const openConfirmModal = () => {
    setConfirmModal(true);
  };

  const closeConfirmModal = () => {
    setConfirmModal(false);
  };

  const handlePageChange = (page: number) => {
    setCurrentPage(page);
    handleGetAllMessages(page);
  };

  const imagesTableHeads = [
    { title: "Sr #", key: "image" },
    { title: "Name", key: "name" },
    { title: "Email", key: "email" },
    { title: "Category", key: "support_message_type" },
    { title: "Message", key: "message" },
    { title: "Action", key: "action" },
  ];

  const handleGetAllMessages = async (page: number) => {
    try {
      setLoading(true);
      const response = await GetAllSupportMessagesService();
      setSupportMessages(response?.data?.data?.data || []);
      setTotalItems(response?.data?.data?.meta?.totalItems || 0);
    } catch (error) {
      console.error("Error fetching images:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    handleGetAllMessages(1);
  }, []);

  const handleDeleteImage = async (id: number) => {
    setDeleteLoading(true);
    try {
      await DeleteSupportMessageService(id);
      toastMessage("success", "Support Message deleted successfully!");
      setSupportMessages((prev: any) =>
        prev.filter((msg: any) => msg.id !== id)
      );
    } catch (error) {
      handleErrors(error);
    } finally {
      setDeleteLoading(false);
      closeConfirmModal();
    }
  };
  return (
    <div className={styles.sectionContainer}>
      <div className={classNames(styles.tableWrapper, "relative")}>
        <CustomTable
          heads={imagesTableHeads}
          title="Support Messages"
          isEmpty={!loading && !messages.length}
        >
          {loading
            ? Array.from({ length: 2 }).map((_, index) => (
                <TableRowLoader key={index} />
              ))
            : messages.map((data, index) => (
                <tr key={data.id}>
                  <td>{index + 1}</td>
                  <td>{data?.name}</td>
                  <td>{data?.email}</td>
                  <td>{data?.support_message_type}</td>
                  <td>{data?.message}</td>
                  <td className="">
                    <div className={classNames(styles.IconsContainer)}>
                      <CustomToolTip label="View">
                        <button
                          onClick={() => {
                            setSelectedMessage(data);
                            handleShowDetails();
                          }}
                        >
                          <Icons.Eye />
                        </button>
                      </CustomToolTip>
                      <CustomToolTip label="Delete">
                        <button
                          onClick={() => {
                            setSelectedMessage(data);
                            openConfirmModal();
                          }}
                          disabled={deleteLoading === data.id}
                        >
                          <Icons.Cross />
                        </button>
                      </CustomToolTip>
                    </div>
                  </td>
                </tr>
              ))}
        </CustomTable>
      </div>

      <CustomPagination
        onPageChange={handlePageChange}
        totalCount={totalItems}
        currentPage={currentPage}
        pageSize={10}
      />
      {confirmModal && (
        // @ts-ignore
        <ConfirmationModal
          show={confirmModal}
          title="Confirm Delete"
          actionButtonText="Yes, Delete"
          subtitle={`Are you sure you want to delete this message?`}
          loading={deleteLoading}
          handleSubmit={() => handleDeleteImage(selectedMessage?.id || 0)}
          handleClose={closeConfirmModal}
        />
      )}

      {showDetails ? (
        <SupportViewModal
          show={showDetails}
          handleClose={handleHideDetails}
          details={selectedMessage}
        />
      ) : null}
    </div>
  );
};

const TableRowLoader = () => (
  <tr>
    {Array.from({ length: 5 }).map((_, index) => (
      <td
        key={index}
        className={classNames(styles.tableContentLabel, "px-2 py-3")}
      >
        <div className="flex items-center justify-center">
          <SkeletonLoader className={styles.lineLoader} />
        </div>
      </td>
    ))}
  </tr>
);

export default SupportMessages;
